import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { toast } from "react-toastify";
import { getAllOrganization, submitRegisterUser } from "../../services/userServicer";
import { useNavigate } from "react-router-dom";
import { PiCaretDown } from "react-icons/pi";
import i18n, { changeLanguage } from "../../i18n"
import { withTranslation } from "react-i18next";
import "./register.css"

interface Reference {
  id: string;
  name: string;
}

interface FormData {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  address: string;
  phone: string;
  password: string;
  confirmPassword: string;
  tenantId: string; // Added tenantId to form data
}

interface Errors {
  [key: string]: string | undefined;
}

interface Organization {
  id: string;
  name: string;
  // Add other organization properties as needed
}

function Register() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<"basic" | "additional">("basic");
  const [currentLanguage, setCurrentLanguage] = useState("en");
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [loadingOrgs, setLoadingOrgs] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    firstName: "",
    lastName: "",
    username: "",
    email: "",
    address: "",
    phone: "",
    password: "",
    confirmPassword: "",
    tenantId: "",
  });
  const [errors, setErrors] = useState<Errors>({});

// Inside the Register component


const [orgError, setOrgError] = useState<string | null>(null);

useEffect(() => {
  const fetchOrganizations = async () => {
    try {
      setLoadingOrgs(true);
      setOrgError(null);
      
      console.log('Starting organizations fetch...');
      const orgs = await getAllOrganization();
      
      if (orgs.length === 0) {
        console.warn('No organizations found');
        setOrgError(t("No organizations available"));
      } else {
        setOrganizations(orgs);
      }
    } catch (error) {
      console.error('Organization fetch failed:', error);
      setOrgError(t("Failed to load organizations. Please try again later."));
    } finally {
      setLoadingOrgs(false);
    }
  };
  
  fetchOrganizations();
}, [t]); // Add t to dependencies if using i18n
 const handleChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
) => {
  const { name, value } = e.target;
  setFormData({ ...formData, [name]: value });
};


 const handleBlur = (
  e: React.FocusEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
) => {
 
};


const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  const newErrors: Errors = {};

  // Validate all fields explicitly
  Object.keys(formData).forEach((key) => {
    const value = formData[key as keyof FormData];

    switch (key) {
      case "firstName":
        newErrors.firstName = !value
          ? t("First_Name_Is_Required") || ""
          : typeof value === "string" && value.length < 3
          ? t("First_Name_Must_Be_At_Least_3_Letters") || ""
          : "";
        break;
      case "lastName":
        newErrors.lastName = !value
          ? t("Last_Name_Is_Required") || ""
          : typeof value === "string" && value.length < 3
          ? t("Last_Name_Must_Be_At_Least_3_Letters") || ""
          : "";
        break;
      case "username":
        newErrors.username = !value ? t("Username_Is_Required") || "" : "";
        break;
      case "email":
        newErrors.email = !value
          ? t("Email_Is_Required") || ""
          : typeof value === "string" && !/\S+@\S+\.\S+/.test(value)
          ? t("Email_Is_Not_Valid") || ""
          : "";
        break;
      case "address":
        newErrors.address = !value ? t("Address_Is_Required") || "" : "";
        break;
      case "phone":
        newErrors.phone = !value
          ? t("Phone_Is_Required") || ""
          : typeof value === "string" &&
            !/^(\+201|01)[0-9]{9}$/.test(value)
          ? t("Phone_Number_Must_Be_A_Valid_Egyptian_Number") || ""
          : "";
        break;
      case "password":
        newErrors.password = !value
          ? t("Password_Is_Required") || ""
          : typeof value === "string" && value.length < 8
          ? t("Password_Must_Be_At_Least_8_Characters") || ""
          : "";
        break;
      case "confirmPassword":
        newErrors.confirmPassword =
          !value || value !== formData.password
            ? t("Passwords_Do_Not_Match") || ""
            : "";
        break;
      case "tenantId":
        newErrors.tenantId = !value ? t("Organization_Is_Required") || "" : "";
        break;
      default:
        break;
    }
  });

  // If any errors exist, prevent submission
  if (Object.values(newErrors).some((error) => error)) {
    setErrors(newErrors);
    toast.error(t("Please correct the errors before submitting"));
    return;
  }

  // Proceed with form submission
  try {
    const { confirmPassword, ...payload } = formData;
    const response = await submitRegisterUser({ ...payload, type: "sup" });

    if (response.isSuccess) {
      toast.success(t("Registration successful!"));
      navigate("/login");
    } else {
      toast.error(response.message || t("Registration failed"));
    }
  } catch (error: any) {
    console.error("Registration error:", error);
    toast.error(error.message || t("An error occurred during registration"));
  }
};


  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLanguage);
    setCurrentLanguage(newLanguage);
    document.documentElement.setAttribute('dir', newLanguage === 'ar' ? 'rtl' : 'ltr');
  };

  return (
    <div className="min-vh-100 bg-light d-flex flex-column flex-lg-row overflow-hidden m-0 p-0">
      {/* Left: Form */}
      <div className="col-lg-6 p-4">
        <div className="text-center mb-4">
          <h3 className="fw-bold">{t("Request To Access")}</h3>
        </div>

        {/* Language Toggle */}
        <div className="position-absolute top-0 end-0 m-3">
          <button
            className="lang-switch bg-white d-flex align-items-center border p-2 rounded-lg"
            onClick={toggleLanguage}
          >
            <img
              src={`/assets/images/${currentLanguage}.jpg`}
              alt={currentLanguage}
              className="flag-icon me-2"
              style={{ width: "24px", height: "24px", objectFit: "cover", borderRadius: "50%" }}
            />
            <span>{currentLanguage === 'en' ? t('header.english') : t('header.arabic')}</span>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="bg-white p-4 rounded shadow-sm">
          <div className="container">
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">{t("First Name")}</label>
                <input
                  type="text"
                  name="firstName"
                  className="form-control"
                  value={formData.firstName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("First Name") || ""}
                />
                {errors.firstName && <div className="text-danger">{errors.firstName}</div>}
              </div>

              <div className="col-md-6">
                <label className="form-label">{t("Last Name")}</label>
                <input
                  type="text"
                  name="lastName"
                  className="form-control"
                  value={formData.lastName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("Last Name") || ""}
                />
                {errors.lastName && <div className="text-danger">{errors.lastName}</div>}
              </div>
            </div>

            {/* Organization Dropdown */}
      {/* Organization Dropdown */}
<div className="mb-3">
  <label className="form-label">{t("Organization")}</label>
  
  {orgError ? (
    <div className="alert alert-danger">
      {orgError}
      <button 
        className="btn btn-sm btn-link ms-2"
        onClick={() => window.location.reload()}
      >
        {t("Retry")}
      </button>
    </div>
  ) : (
    <select
      name="tenantId"
      className={`form-control ${errors.tenantId ? 'is-invalid' : ''}`}
      value={formData.tenantId}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={loadingOrgs}
      required
    >
      <option value="">{loadingOrgs ? t("Loading organizations...") : t("Select Organization")}</option>
      {organizations.map(org => (
        <option key={org.id} value={org.id}>
          {org.name}
        </option>
      ))}
    </select>
  )}
  
  {errors.tenantId && !orgError && (
    <div className="invalid-feedback">{errors.tenantId}</div>
  )}
</div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">{t("Username")}</label>
                <input
                  type="text"
                  name="username"
                  className="form-control"
                  value={formData.username}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("Username") || ""}
                />
                {errors.username && <div className="text-danger">{errors.username}</div>}
              </div>

              <div className="col-md-6">
                <label className="form-label">{t("Email")}</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("Email") || ""}
                />
                {errors.email && <div className="text-danger">{errors.email}</div>}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">{t("Address")}</label>
                <input
                  type="text"
                  name="address"
                  className="form-control"
                  value={formData.address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("Address") || ""}
                />
                {errors.address && <div className="text-danger">{errors.address}</div>}
              </div>

              <div className="col-md-6">
                <label className="form-label">{t("Phone")}</label>
                <input
                  type="tel"
                  name="phone"
                  className="form-control"
                  value={formData.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={t("Phone") || ""}
                />
                {errors.phone && <div className="text-danger">{errors.phone}</div>}
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">{t("Password")}</label>
              <input
                type="password"
                name="password"
                className="form-control"
                value={formData.password}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={t("Password") || ""}
              />
              {errors.password && <div className="text-danger">{errors.password}</div>}
            </div>

            <div className="mb-3">
              <label className="form-label">{t("Confirm Password")}</label>
              <input
                type="password"
                name="confirmPassword"
                className="form-control"
                value={formData.confirmPassword}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              {errors.confirmPassword && <div className="text-danger">{errors.confirmPassword}</div>}
            </div>
            
            <div className="text-center mt-4">
              <button type="submit" className="btn-register px-5 w-50">
                {t("Sign Up")}
              </button>
            </div>

            <div className="text-center mt-3">
              <p>
                {t("Already have an account?")}{" "}
                <a href="/login" className="text-primary text-decoration-underline">{t("Login here")}</a>
              </p>
            </div>
          </div>
        </form>
      </div>

      {/* Right: Image */}
      <div className="col-lg-6 d-none d-lg-block p-0 m-0">
        <div className="h-100 logoimag">
          <img
            src="/assets/images/register.png"
            alt="Request Access"
            className="top-0 start-0 w-100 bject-fit-cover logo left-0"
          />
        </div>
      </div>
    </div>
  );
}



export default Register;